import React from 'react';
import 'swiper/swiper-bundle.css'; // Core Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import posts from '../data/data-room.json';

function RoomOne() {
    console.log(posts); // Debug: Check if multiple rooms exist

    return (
    <></>  
    );
}

export default RoomOne;
